<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
      Part Dealer List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Part Dealer
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
      :options="{'itemsPerPage':50}"
    >
    
     
     <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-icon
        small
        class="mr-2"
        @click="editData(item.id)"
        v-if="role.update"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.id)"
         v-if="role.delete"
      >
        mdi-delete
      </v-icon> -->
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="role.update" @click="editData(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.delete" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage
  },
    vuetify,
    data () {
      return {
        loadTable: true, 
        role: "",
        search: '',
        headers: [
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
          {
            text: 'Dealer No.',
            align: 'start',
            value: 'dealer_no', width:'120'
          },
          { text: 'Dealer Name', value: 'dealer_name', width:'200' },
          { text: 'Use PPN', value: 'dealer_use_ppn', width:'80' },
          { text: 'Dealer Attn', value: 'dealer_attn', width:'100' },
          { text: 'Phone', value: 'dealer_phone' },
          { text: 'Address', value: 'dealer_address', width:'350' },
          { text: 'Bank Name', value: 'dealer_bank_name', width:'200' },
          { text: 'Bank Account', value: 'dealer_bank_account' },
          { text: 'Remark', value: 'dealer_remark', width:'200' },
          { text: 'Created At', value: 'created_at', align: 'center', width:'200'},
        ],
        table: [],
        worksheetName: "Part Dealer",
        fileName:"Part Dealer.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
         'no': 'no',
        'dealer_no' : 'dealer_no',
        'dealer_name' : 'dealer_name',
        'dealer_use_ppn' : 'dealer_use_ppn',
        'dealer_attn' : 'dealer_attn',
        'dealer_phone' : 'dealer_phone',
        'dealer_address' : 'dealer_address',
        'dealer_bank_name' : 'dealer_bank_name',
        'dealer_bank_account' : 'dealer_bank_account',
        'dealer_remark' : 'dealer_remark',
        'created_at' : 'created_at',
        'updated_at' : 'updated_at'
        },
      }
    },
    async created() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
     
      await this.$store.dispatch("workshop_part_dealer/list");
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_part_dealer/list"];
      // }
      // else{
      //   this.table = []
      // }
      this.loadTable= false
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    if(this.$refs.vTable){
      this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    }
    else{
      this.exportAllFitered = this.dataExport(this.table)
    }
    },

     
    // fungsi tombol direct ke add page
    addData() {
      // panggil add page
      this.$router.push({name: 'Add Part Dealer'});
    },

    // fungsi tombol direct ke edit page
    editData(id) {
      // panggil edit page
     this.$router.push({ name: 'Edit Part Dealer', params: { id: id } })
    },

  
    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

     // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_part_dealer/destroy", id)
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Data Part Dealer delete successfully.")
        //await this.getList();
        var indexOptionTable = this.table.findIndex(p => p.id ==  id)
           this.table.splice(indexOptionTable, 1)
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
    dataExport(data){
      return data.map((v,index) => ({...v, no: index+1}))
      
     
  }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>